import styled from 'styled-components/macro';

import { ReactComponent as CarouselBackSvg } from 'components/svg/CarouselBack.svg';

export const BackSvg = styled(CarouselBackSvg)`
  height: 23px;
  width: 23px;
`;
